module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    directives: [{
      name: "lang",
      rawName: "v-lang.latest_posts",
      modifiers: {
        "latest_posts": true
      }
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "latest_posts"
  }, _vm._l((_vm.posts), function(post) {
    return _c('article', {
      staticClass: "latest_post"
    }, [_c('div', {
      staticClass: "details"
    }, [_c('h6', [_c('a', [_vm._v(_vm._s(post.title))])]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(_vm._s(_vm.formatDate(post.createdAt)))])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e614314"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/singleRoom/widgets/lastPosts.vue
// module id = 358
// module chunks = 0